import { JobChangeAlertMessage } from '@aibees/elephant/components/job-change-alert-message';
import { usePersonReadDataContext } from '@aibees/elephant/context';
import { ContactDetailItemHeader } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-detail-item-header';
import { useSetSeemoreVisibility } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/hooks/use-set-seemore-visibility';
import { Scrollbar } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack } from '@mui/material';
import { memo } from 'react';
import { useContactDetailsState } from '../../context';
import * as EXTERNALSX from '../../sx';
import { WorkHistoryItem } from './components/work-history-item';
import { useWorkHistoryFullHistory } from './hooks';
import * as SX from './sx';
import type { WorkHistoryProps as Props } from './types';

export const WorkHistory = memo(
  ({ className, itemsLimit, setShowSeeMore }: Props) => {
    const fullWorkHistory = useWorkHistoryFullHistory();
    const { api: personApi } = usePersonReadDataContext();
    useSetSeemoreVisibility(setShowSeeMore, itemsLimit, fullWorkHistory.length);
    const { isPopoverType } = useContactDetailsState();

    const content = (
      <Stack gap={1}>
        {fullWorkHistory.map((item, index) => {
          if (!!itemsLimit && index >= itemsLimit) return null;
          const isLastItem = index === 0;
          return (
            <WorkHistoryItem
              isSidebar
              key={index.toString()}
              item={item}
              isLastItem={isLastItem}
              personData={personApi?.data}
            />
          );
        })}
      </Stack>
    );

    return (
      <Box className={classnames('WorkHistory', className)} sx={SX.root}>
        <ContactDetailItemHeader
          title="Work History"
          count={fullWorkHistory.length}
        />
        <JobChangeAlertMessage />

        {isPopoverType ? (
          <Scrollbar sx={EXTERNALSX.generalProfileDetailsScrollbar}>
            {content}
          </Scrollbar>
        ) : (
          content
        )}
      </Box>
    );
  }
);

WorkHistory.displayName = 'WorkHistory';
